import { commentParams, normalizeCollectionResponse } from 'api';
import { client, computeHeaders } from 'queries';

export const commentsQuery = async ({ req, params }) => {
	const formattedUrl = `/discussions/${params.discussionId}/comments`;
	const formattedParams = { ...commentParams, context: ['ssr'] };
	const headers = computeHeaders(req);
	const response = await client.apiRequest({ url: formattedUrl, headers, params: formattedParams });
	return normalizeCollectionResponse(response);
};
